import * as React from 'react';
import CallbackHelpers from '../../shared-common/helpers/CallbackHelpers';
import Helpers from '../../shared-common/helpers/Helpers';

export interface SelectionGroupProps {
  hasSelectionManager: boolean;
  selectedValues: unknown[];
  onSelected(value: unknown): void;
  onDeselected(value: unknown): void;
  equalityComparer(a: any, b: any): boolean;
}

export const SelectionManager = React.createContext<SelectionGroupProps>({
  hasSelectionManager: false,
  selectedValues: [],
  onSelected: CallbackHelpers.NoOp,
  onDeselected: CallbackHelpers.NoOp,
  equalityComparer: Helpers.areSameValueOrZero
});
